document.addEventListener("DOMContentLoaded", function () {

  /* --------------------------------------------------------------------------
     1. FORMATTING & PRICE UTILITIES
     -------------------------------------------------------------------------- */
  function formatMoney(num) {
    return "₹" + Number(num).toLocaleString("en-IN");
  }

  // function getBasePrice() {
  //   var baseEl = document.getElementById("yumiBasePrice");
  //   if (!baseEl) return 0;
  //   var raw = baseEl.getAttribute("data-price") || baseEl.innerText.replace(/[^0-9.]/g, "");
  //   return parseFloat(raw) || 0;
  // }

  function getBasePrice() {
    var baseEl = document.getElementById("yumiBasePrice");

    // Shopify product form ka currently selected variant
    var variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (variantInput && variantInput.value) {
      var variantId = String(variantInput.value);

      // Shopify variant data available ho to usse price lo
      if (window.yumiProductVariants) {
        var variant = window.yumiProductVariants.find(function (v) {
          return String(v.id) === variantId;
        });

        if (variant && variant.price != null) {
          return Number(variant.price) / 100;
        }
      }
    }

    // Fallback
    if (!baseEl) return 0;

    var raw =
      baseEl.getAttribute("data-price") ||
      baseEl.innerText.replace(/[^0-9.]/g, "");

    return parseFloat(raw) || 0;
  }


  /* --------------------------------------------------------------------------
     2. BAG TAG FORM STATE
     -------------------------------------------------------------------------- */
  var bagTagState = {
    selectedHandle: null,
    selectedVariant: null,
    printMode: "no", // 'no' or 'yes'
    details: {
      name: "",
      grade: "",
      contact: ""
    }
  };

  /* --------------------------------------------------------------------------
     3. DYNAMIC TOTAL & LIVE SUMMARY RECALCULATION
     -------------------------------------------------------------------------- */
  function recalculateGrandTotal() {
    var basePrice = getBasePrice();
    var addonTotal = 0;
    var breakdownList = document.getElementById("yumiAddonBreakdown");
    var breakdownHtml = "";

    // Iterate through all addon cards
    document.querySelectorAll(".yumi-addon-card").forEach(function (card) {
      var checkbox = card.querySelector(".addon-checkbox");
      if (!checkbox || !checkbox.checked) return;

      var addonName = checkbox.getAttribute("data-addon-name") || "Custom Add-on";
      var addonPrice = parseFloat(checkbox.getAttribute("data-base-price") || 0);

      // Check if generic radio swatch is selected
      var selectedRadio = card.querySelector("input.addon-radio-input:checked");
      if (selectedRadio && selectedRadio.getAttribute("data-price")) {
        addonPrice = parseFloat(selectedRadio.getAttribute("data-price") || addonPrice);
        var variantName = selectedRadio.getAttribute("data-name");
        if (variantName) {
          addonName += " (" + variantName + ")";
        }
      }

      // Check Bag Tag specifically (reads actual selected tag price from Shopify)
      if (card.classList.contains("addon-bagtag-card")) {
        if (bagTagState.selectedVariant && bagTagState.selectedVariant.price) {
          addonPrice = parseFloat(bagTagState.selectedVariant.price);
          addonName = "Bag Tag (" + bagTagState.selectedVariant.name + ")";
        } else {
          var activeTagSwatch = card.querySelector(".bagtag-variant-item.active");
          if (activeTagSwatch && activeTagSwatch.getAttribute("data-price")) {
            addonPrice = parseFloat(activeTagSwatch.getAttribute("data-price"));
            var sName = activeTagSwatch.getAttribute("data-name");
            if (sName) addonName = "Bag Tag (" + sName + ")";
          }
        }

        if (bagTagState.printMode === "yes") {
          addonName += " + Custom Print";
        }
      }

      addonTotal += addonPrice;

      var addonComparePrice = parseFloat(checkbox.getAttribute("data-compare-price") || 0);
      var priceHtml = "";
      if (addonPrice > 0) {
        if (addonComparePrice > addonPrice) {
          priceHtml = `<s style="color:#9c958d;text-decoration:line-through;margin-right:6px;font-size:12px;">${formatMoney(addonComparePrice)}</s><span>${formatMoney(addonPrice)}</span>`;
        } else {
          priceHtml = formatMoney(addonPrice);
        }
      } else {
        if (addonComparePrice > 0) {
          priceHtml = `<s style="color:#9c958d;text-decoration:line-through;margin-right:6px;font-size:12px;">${formatMoney(addonComparePrice)}</s><span style="color:#27ae60;font-weight:700;">${formatMoney(0)}</span>`;
        } else {
          priceHtml = `<span style="color:#27ae60;font-weight:700;">${formatMoney(0)}</span>`;
        }
      }

      breakdownHtml += `
        <div class="yumi-price-summary__row yumi-price-summary__row--addon">
          <span>+ ${addonName}</span>
          <span>${priceHtml}</span>
        </div>
      `;
    });

    // Update Breakdown DOM
    if (breakdownList) {
      breakdownList.innerHTML = breakdownHtml;
    }

    var addonSummaryRow = document.getElementById("yumiAddonSummaryRow");
    var addonPriceEl = document.getElementById("yumiAddonPrice");
    if (addonPriceEl) {
      addonPriceEl.innerText = formatMoney(addonTotal);
      if (addonSummaryRow) {
        addonSummaryRow.style.display = addonTotal > 0 ? "flex" : "none";
      }
    }

    var qtyInput = document.querySelector(".yumi-quantity-input");
    var currentQty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
    var minQty = qtyInput ? (parseInt(qtyInput.getAttribute("min")) || parseInt(qtyInput.getAttribute("data-min-qty")) || 1) : 1;
    var isBulk = minQty > 1;

    var unitTotal = basePrice + addonTotal;
    var grandTotal = isBulk ? (unitTotal * currentQty) : unitTotal;

    var finalPriceEl = document.getElementById("yumiFinalPrice");
    if (finalPriceEl) {
      finalPriceEl.innerText = formatMoney(isBulk ? grandTotal : unitTotal);
    }

    // Update Primary CTA text
    var cartPriceLabel = document.getElementById("cartPriceLabel");
    var addToCartBtn = document.getElementById("addToCartBtn");
    if (addToCartBtn && !addToCartBtn.disabled) {
      var btnSpan = addToCartBtn.querySelector("span");
      if (btnSpan) {
        if (isBulk) {
          btnSpan.innerHTML = 'Add To Cart (' + currentQty + ' Units) — <strong id="cartPriceLabel">' + formatMoney(grandTotal) + '</strong>';
        } else {
          btnSpan.innerHTML = 'Add To Cart — <strong id="cartPriceLabel">' + formatMoney(grandTotal) + '</strong>';
        }
      } else if (cartPriceLabel) {
        cartPriceLabel.innerText = formatMoney(grandTotal);
      }
    } else if (cartPriceLabel) {
      cartPriceLabel.innerText = formatMoney(grandTotal);
    }
  }

  /* --------------------------------------------------------------------------
   SHOPIFY VARIANT CHANGE → UPDATE YUMI PRICE
   -------------------------------------------------------------------------- */

  document.addEventListener("change", function (event) {

    // Check if change happened inside Shopify variant picker
    var variantPicker = event.target.closest("variant-radios");

    if (!variantPicker) return;

    // Wait for Shopify's variant code to update the hidden variant ID
    setTimeout(function () {
      recalculateGrandTotal();
    }, 100);

  });


  /* --------------------------------------------------------------------------
     4. TOGGLE SWITCH EVENT HANDLERS
     -------------------------------------------------------------------------- */
  document.addEventListener("change", function (e) {
    if (e.target.classList.contains("addon-checkbox")) {
      var card = e.target.closest(".yumi-addon-toggle") || e.target.closest(".yumi-addon-card");
      if (card) {
        card.classList.toggle("active", e.target.checked);
      }
      recalculateGrandTotal();
    }
  });

  /* --------------------------------------------------------------------------
     5. LIVE EMBROIDERED NAME PREVIEW & CHAR COUNTER
     -------------------------------------------------------------------------- */
  document.querySelectorAll(".addon-name-input").forEach(function (input) {
    var parentWrap = input.closest(".yumi-name-input-wrap");
    var parentCard = input.closest(".yumi-addon-card");
    var charCountEl = parentWrap ? parentWrap.querySelector(".yumi-chars-current") : null;
    var previewBadge = parentWrap ? parentWrap.querySelector(".yumi-name-preview__badge") : null;

    input.addEventListener("input", function () {
      var val = this.value.trim();
      if (charCountEl) {
        charCountEl.innerText = this.value.length;
      }
      if (previewBadge) {
        previewBadge.innerText = val.length > 0 ? val : "Your Name";
      }

      // Propagate to corresponding hidden field
      if (parentCard) {
        var hiddenOrder = parentCard.querySelector(".addon-order");
        if (hiddenOrder) hiddenOrder.value = val;

        var addonType = parentCard.getAttribute("data-addon-type") || "";
        if (addonType.indexOf("initial") !== -1) {
          var propInitials = document.getElementById("propInitials");
          if (propInitials) propInitials.value = val;
        } else if (addonType.indexOf("patch") !== -1) {
          var propPatch = document.getElementById("propPatch");
          if (propPatch) propPatch.value = val;
        } else if (addonType.indexOf("acrylic") !== -1) {
          var propKeychain = document.getElementById("propKeychain");
          if (propKeychain) propKeychain.value = val;
        } else if (addonType.indexOf("tumbler") !== -1 || addonType.indexOf("bottle") !== -1 || addonType.indexOf("sipper") !== -1) {
          var propTumblerName = document.getElementById("propTumblerName");
          if (propTumblerName) propTumblerName.value = val;
        } else if (addonType.indexOf("cap") !== -1 || addonType.indexOf("hat") !== -1) {
          var propCapName = document.getElementById("propCapName");
          if (propCapName) propCapName.value = val;
        }
      }
    });
  });

  /* --------------------------------------------------------------------------
     6. GENERIC SWATCH SELECTION
     -------------------------------------------------------------------------- */
  document.addEventListener("change", function (e) {
    if (e.target.type === "radio" && e.target.classList.contains("addon-radio-input")) {
      var card = e.target.closest(".yumi-addon-card");
      if (!card) return;

      // Update swatch card active classes
      card.querySelectorAll(".yumi-swatch-card").forEach(function (swatch) {
        swatch.classList.remove("active", "yumi-swatch-card--active");
      });
      var parentLabel = e.target.closest(".yumi-swatch-card");
      if (parentLabel) {
        parentLabel.classList.add("active", "yumi-swatch-card--active");
      }

      // Update selection info bar
      var display = card.querySelector(".selected-value");
      var selectionBar = card.querySelector(".addon-selected");
      if (display) {
        var vName = e.target.getAttribute("data-name") || "";
        var vPrice = e.target.getAttribute("data-price") || "";
        display.innerText = vName + " (" + formatMoney(vPrice) + ")";
        if (selectionBar) selectionBar.style.display = "flex";
      }

      recalculateGrandTotal();
    }
  });

  // Remove selection button
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("remove-selection") && !e.target.classList.contains("bagtag-remove-btn")) {
      var card = e.target.closest(".yumi-addon-card");
      if (!card) return;

      card.querySelectorAll("input[type='radio']").forEach(function (r) {
        r.checked = false;
      });
      card.querySelectorAll(".yumi-swatch-card").forEach(function (swatch) {
        swatch.classList.remove("active", "yumi-swatch-card--active");
      });

      var display = card.querySelector(".selected-value");
      var selectionBar = card.querySelector(".addon-selected");
      if (display) display.innerText = "";
      if (selectionBar) selectionBar.style.display = "none";

      recalculateGrandTotal();
    }
  });

  /* --------------------------------------------------------------------------
     7. BAG TAG MULTI-STEP BUILDER
     -------------------------------------------------------------------------- */
  var bagtagCard = document.querySelector(".addon-bagtag-card");

  if (bagtagCard) {
    var step1 = bagtagCard.querySelector(".bagtag-step-1");
    var step2 = bagtagCard.querySelector(".bagtag-step-2");
    var variantsGrid = bagtagCard.querySelector(".bagtag-variants");
    var backBtn = bagtagCard.querySelector(".bagtag-back-btn");
    var selectedBar = bagtagCard.querySelector(".bagtag-selected-bar");
    var selectedText = selectedBar ? selectedBar.querySelector(".selected-value") : null;
    var printWrapper = bagtagCard.querySelector(".bagtag-print-wrapper");
    var detailsCard = bagtagCard.querySelector(".bagtag-details-card");

    // Modal elements
    var modalBackdrop = document.getElementById("yumiBagTagModalBackdrop");
    var modalEl = document.getElementById("yumiBagTagModal");
    var modalClose = document.getElementById("yumiModalClose");
    var modalCancel = document.getElementById("yumiModalCancel");
    var modalSave = document.getElementById("yumiModalSave");

    var inputName = document.getElementById("modalInputName");
    var inputClass = document.getElementById("modalInputClass");
    var inputContact = document.getElementById("modalInputContact");

    // Step 1: Collection Click -> Load Variants
    bagtagCard.querySelectorAll(".bagtag-collection-item").forEach(function (item) {
      item.addEventListener("click", function () {
        bagtagCard.querySelectorAll(".bagtag-collection-item").forEach(function (c) {
          c.classList.remove("active");
        });
        this.classList.add("active");

        var handle = this.getAttribute("data-handle");
        bagTagState.selectedHandle = handle;

        if (window.bagTagData && window.bagTagData[handle]) {
          var variants = window.bagTagData[handle];
          var html = "";

          variants.forEach(function (v) {
            var mediaHtml = (v.image && v.image !== "undefined" && v.image !== "")
              ? `<img src="${v.image}" class="yumi-swatch-card__img" alt="${v.name}">`
              : `<div class="yumi-swatch-card__img" style="font-size:24px; display:flex; align-items:center; justify-content:center; background:#FDF3ED;">${v.icon || '🏷️'}</div>`;

            var priceDisplay = (parseFloat(v.price) === 0)
              ? (parseFloat(v.compare_price || 0) > 0 
                  ? `<s style="color:#9c958d;font-size:11px;text-decoration:line-through;margin-right:4px;">${formatMoney(v.compare_price)}</s><span style="color:#27ae60;font-weight:700;">Free</span>`
                  : `<span style="color:#27ae60;font-weight:700;">Free</span>`)
              : `+ ${formatMoney(v.price)}`;

            html += `
              <label class="yumi-swatch-card bagtag-variant-item" data-id="${v.id}" data-name="${v.name}" data-price="${v.price}">
                <input type="radio" name="bagtag-variant-radio" class="bagtag-radio" data-id="${v.id}" data-name="${v.name}" data-price="${v.price}" style="display:none;">
                ${mediaHtml}
                <span class="yumi-swatch-card__label">${v.name}</span>
                <span class="yumi-swatch-card__price">${priceDisplay}</span>
              </label>
            `;
          });

          if (variantsGrid) variantsGrid.innerHTML = html;

          if (step1) step1.style.display = "none";
          if (step2) step2.style.display = "block";
        }
      });
    });

    // Step 2: Back to Collections Button
    if (backBtn) {
      backBtn.addEventListener("click", function () {
        if (step2) step2.style.display = "none";
        if (step1) step1.style.display = "block";
      });
    }

    // Step 2: Variant Swatch Click
    document.addEventListener("click", function (e) {
      var swatch = e.target.closest(".bagtag-variant-item");
      if (!swatch) return;

      bagtagCard.querySelectorAll(".bagtag-variant-item").forEach(function (s) {
        s.classList.remove("active", "yumi-swatch-card--active");
      });
      swatch.classList.add("active", "yumi-swatch-card--active");

      var radio = swatch.querySelector(".bagtag-radio");
      if (radio) radio.checked = true;

      var vId = swatch.getAttribute("data-id");
      var vName = swatch.getAttribute("data-name");
      var vPrice = swatch.getAttribute("data-price");

      bagTagState.selectedVariant = { id: vId, name: vName, price: vPrice };

      // Update hidden properties
      var propBagTag = document.getElementById("propBagTag");
      if (propBagTag) propBagTag.value = vName;

      // Show selection bar & print options
      var isFreeTag = (parseFloat(vPrice) === 0);
      if (selectedText) selectedText.innerText = vName + (isFreeTag ? " (Free)" : " (" + formatMoney(vPrice) + ")");
      if (selectedBar) selectedBar.style.display = "flex";
      if (printWrapper) printWrapper.style.display = "block";

      recalculateGrandTotal();
    });

    // Remove Tag Button
    var removeTagBtn = bagtagCard.querySelector(".bagtag-remove-btn");
    if (removeTagBtn) {
      removeTagBtn.addEventListener("click", function () {
        bagTagState.selectedVariant = null;
        bagtagCard.querySelectorAll(".bagtag-variant-item").forEach(function (s) {
          s.classList.remove("active", "yumi-swatch-card--active");
          var r = s.querySelector(".bagtag-radio");
          if (r) r.checked = false;
        });

        if (selectedBar) selectedBar.style.display = "none";
        if (printWrapper) printWrapper.style.display = "none";

        var propBagTag = document.getElementById("propBagTag");
        if (propBagTag) propBagTag.value = "";

        resetPrintDetails();
        recalculateGrandTotal();

      });
    }

    // Print Radio Change (Standard vs Personalised)
    bagtagCard.querySelectorAll(".bagtag-print-radio").forEach(function (radio) {
      radio.addEventListener("change", function () {
        if (this.value === "yes") {
          bagTagState.printMode = "yes";
          openModal();
        } else {
          bagTagState.printMode = "no";
          if (detailsCard) detailsCard.style.display = "none";
          resetPrintHiddenProps();
          recalculateGrandTotal();

        }
      });
    });

    // Modal Helpers
    function openModal() {
      if (inputName) inputName.value = bagTagState.details.name || "";
      if (inputClass) inputClass.value = bagTagState.details.grade || "";
      if (inputContact) inputContact.value = bagTagState.details.contact || "";

      if (modalBackdrop) modalBackdrop.classList.add("active");
      if (modalEl) modalEl.classList.add("active");
    }

    function closeModal() {
      if (modalBackdrop) modalBackdrop.classList.remove("active");
      if (modalEl) modalEl.classList.remove("active");
    }

    function resetPrintDetails() {
      bagTagState.printMode = "no";
      bagTagState.details = { name: "", grade: "", contact: "" };
      var standardRadio = bagtagCard.querySelector(".bagtag-print-radio[value='no']");
      if (standardRadio) standardRadio.checked = true;
      if (detailsCard) detailsCard.style.display = "none";
      resetPrintHiddenProps();
    }

    function resetPrintHiddenProps() {
      var pName = document.getElementById("propBagTagName");
      var pClass = document.getElementById("propBagTagClass");
      var pContact = document.getElementById("propBagTagContact");
      var pPrint = document.getElementById("propBagTagPrint");
      var pPrintPrice = document.getElementById("propBagTagPrintPrice");

      if (pName) pName.value = "";
      if (pClass) pClass.value = "";
      if (pContact) pContact.value = "";
      if (pPrint) pPrint.value = "no";
      if (pPrintPrice) pPrintPrice.value = "0";
    }

    if (modalClose) modalClose.addEventListener("click", closeModal);
    if (modalBackdrop) modalBackdrop.addEventListener("click", closeModal);
    if (modalCancel) {
      modalCancel.addEventListener("click", function () {
        closeModal();
        if (!bagTagState.details.name) {
          resetPrintDetails();
          recalculateGrandTotal();
        }
      });
    }

    // Modal Save Action
    if (modalSave) {
      modalSave.addEventListener("click", function () {
        var name = inputName ? inputName.value.trim() : "";
        var contact = inputContact ? inputContact.value.trim() : "";
        var grade = inputClass ? inputClass.value.trim() : "";

        if (!name) {
          alert("Please enter Child's Full Name");
          if (inputName) inputName.focus();
          return;
        }

        if (!contact) {
          alert("Please enter Emergency Contact Number");
          if (inputContact) inputContact.focus();
          return;
        }

        bagTagState.details = { name: name, grade: grade, contact: contact };
        bagTagState.printMode = "yes";

        // Update hidden form fields for Shopify cart
        var pName = document.getElementById("propBagTagName");
        var pClass = document.getElementById("propBagTagClass");
        var pContact = document.getElementById("propBagTagContact");
        var pPrint = document.getElementById("propBagTagPrint");
        var pPrintPrice = document.getElementById("propBagTagPrintPrice");

        if (pName) pName.value = name;
        if (pClass) pClass.value = grade;
        if (pContact) pContact.value = contact;
        if (pPrint) pPrint.value = "yes";
        if (pPrintPrice) pPrintPrice.value = "0";

        // Update Details Card Summary
        if (detailsCard) {
          var dtName = detailsCard.querySelector(".dt-name");
          var dtClass = detailsCard.querySelector(".dt-class");
          var dtContact = detailsCard.querySelector(".dt-contact");

          if (dtName) dtName.innerText = name;
          if (dtClass) dtClass.innerText = grade || "-";
          if (dtContact) dtContact.innerText = contact;

          detailsCard.style.display = "block";
        }

        closeModal();
        recalculateGrandTotal();
      });
    }

    // Edit Details Button
    var editBtn = bagtagCard.querySelector(".btn-edit-print");
    if (editBtn) {
      editBtn.addEventListener("click", openModal);
    }

    // Clear Print Button
    var clearPrintBtn = bagtagCard.querySelector(".btn-clear-print");
    if (clearPrintBtn) {
      clearPrintBtn.addEventListener("click", function () {
        resetPrintDetails();
        recalculateGrandTotal();
      });
    }
  }

  /* --------------------------------------------------------------------------
     8. QUANTITY SELECTOR, MOQ NOTICE & ACCORDIONS
     -------------------------------------------------------------------------- */
  function showMoqNotice(minQty) {
    var card = document.getElementById("yumiBulkMoqCard");
    if (card) {
      card.style.transition = "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease";
      card.style.borderColor = "#F1A37C";
      card.style.transform = "scale(1.02)";
      card.style.boxShadow = "0 6px 20px rgba(241, 163, 124, 0.35)";
      setTimeout(function () {
        card.style.transform = "scale(1)";
        card.style.boxShadow = "none";
      }, 400);
    }

    var existingToast = document.getElementById("yumiMoqToast");
    if (existingToast) existingToast.remove();

    var toast = document.createElement("div");
    toast.id = "yumiMoqToast";
    toast.style.cssText = "position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%); background: #2B231D; color: #FFF; padding: 12px 20px; border-radius: 50px; font-size: 13px; font-weight: 700; z-index: 999999; box-shadow: 0 8px 24px rgba(0,0,0,0.25); display: flex; align-items: center; gap: 8px;";
    toast.innerHTML = '<span>📦 Minimum order is ' + minQty + ' units. Inquire for ₹799 bulk pricing!</span>';
    document.body.appendChild(toast);

    setTimeout(function () {
      toast.style.opacity = "0";
      toast.style.transition = "opacity 0.3s ease";
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
    }, 3200);
  }

  document.querySelectorAll(".yumi-quantity-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var container = this.closest(".yumi-quantity-selector");
      if (!container) return;
      var input = container.querySelector(".yumi-quantity-input");
      if (!input) return;

      var current = parseInt(input.value) || 1;
      var minQty = parseInt(input.getAttribute("min")) || parseInt(input.getAttribute("data-min-qty")) || 1;
      var isMinus = this.getAttribute("name") === "minus" || this.classList.contains("quantity-minus") || this.classList.contains("qty-minus");

      if (isMinus) {
        if (current > minQty) {
          input.value = current - 1;
        } else {
          if (minQty > 1) {
            showMoqNotice(minQty);
          }
          return;
        }
      } else {
        input.value = current + 1;
      }
      recalculateGrandTotal();
    });
  });

  document.querySelectorAll(".yumi-quantity-input").forEach(function (input) {
    input.addEventListener("change", function () {
      var minQty = parseInt(this.getAttribute("min")) || parseInt(this.getAttribute("data-min-qty")) || 1;
      var val = parseInt(this.value) || minQty;
      if (val < minQty) {
        this.value = minQty;
        showMoqNotice(minQty);
      }
      recalculateGrandTotal();
    });
  });

  // Wishlist Button is handled globally by assets/wishlist.js

  // Accordions
  document.querySelectorAll(".yumi-accordion__trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var acc = this.closest(".yumi-accordion");
      if (acc) {
        acc.classList.toggle("active");
      }
    });
  });

  /* --------------------------------------------------------------------------
     9. PRODUCT GALLERY THUMBNAIL SWITCHER & ZOOM
     -------------------------------------------------------------------------- */
  function initProductGallery() {
    var gallery = document.querySelector(".yumi-product-gallery");
    if (!gallery) return;

    var mainSlides = gallery.querySelectorAll(".yumi-product-gallery__slide");
    var thumbItems = gallery.querySelectorAll(".yumi-product-gallery__thumb");
    var zoomBackdrop = document.getElementById("yumiZoomBackdrop");
    var zoomModal = document.getElementById("yumiZoomModal");
    var zoomImg = document.getElementById("yumiZoomImg");
    var zoomClose = document.getElementById("yumiZoomClose");
    var zoomBtn = document.getElementById("zoomBtn");
    var mainImageWrap = document.getElementById("mainImageWrap");
    var thumbStrip = document.getElementById("thumbStrip") || gallery.querySelector(".yumi-product-gallery__thumbs");
    var thumbWrap = document.getElementById("thumbStripWrap") || gallery.querySelector(".yumi-product-gallery__thumbs-wrap");
    var navUp = document.getElementById("thumbNavUp");
    var navDown = document.getElementById("thumbNavDown");

    // === DEFINITIVE SCROLL-TOP LOCK ===
    // Prevent browser scroll-restoration + external scripts from pushing
    // thumbStrip down on page load. We run a requestAnimationFrame loop
    // for 1500ms that forcibly keeps scrollTop=0 until the user physically
    // interacts with the strip.
    if ("scrollRestoration" in history) {
      try { history.scrollRestoration = "manual"; } catch(e) {}
    }

    var userScrolledThumbs = false;
    var thumbLockUntil = Date.now() + 1500; // lock for 1.5 seconds

    // Mark user interaction — only pointer/touch, NOT wheel (wheel fires on page too early)
    function markUserScrolled() { userScrolledThumbs = true; }

    // Helper: Update Up/Down navigation buttons visibility & state
    function updateThumbNav() {
      if (!thumbStrip || !navUp || !navDown) return;
      if (window.innerWidth < 990) {
        navUp.style.display = "none";
        navDown.style.display = "none";
        return;
      }
      var canScroll = thumbStrip.scrollHeight > (thumbStrip.clientHeight + 4);
      if (canScroll) {
        navUp.style.display = "flex";
        navDown.style.display = "flex";
        var atTop = thumbStrip.scrollTop <= 2;
        navUp.style.opacity = atTop ? "0.35" : "1";
        navUp.style.pointerEvents = atTop ? "none" : "auto";
        var atBottom = (thumbStrip.scrollTop + thumbStrip.clientHeight) >= (thumbStrip.scrollHeight - 2);
        navDown.style.opacity = atBottom ? "0.35" : "1";
        navDown.style.pointerEvents = atBottom ? "none" : "auto";
      } else {
        navUp.style.display = "none";
        navDown.style.display = "none";
      }
    }

    // RAF-based continuous lock: resets scrollTop=0 every frame during the lock window
    function rafLockThumbTop() {
      if (!thumbStrip || userScrolledThumbs) return;
      if (thumbStrip.scrollTop !== 0) {
        thumbStrip.scrollTop = 0;
        updateThumbNav();
      }
      if (Date.now() < thumbLockUntil) {
        requestAnimationFrame(rafLockThumbTop);
      }
    }

    // Bind navigation buttons
    if (navUp && !navUp.dataset.bound) {
      navUp.dataset.bound = "true";
      navUp.addEventListener("click", function(e) {
        e.preventDefault();
        userScrolledThumbs = true; // User explicitly interacted
        if (thumbStrip) {
          thumbStrip.scrollBy({ top: -160, behavior: "smooth" });
          setTimeout(function() {
            if (thumbStrip.scrollTop < 20) {
              thumbStrip.scrollTop = 0;
              userScrolledThumbs = false; // allow re-lock if scrolled back to top
            }
            updateThumbNav();
          }, 350);
        }
      });
    }

    if (navDown && !navDown.dataset.bound) {
      navDown.dataset.bound = "true";
      navDown.addEventListener("click", function(e) {
        e.preventDefault();
        userScrolledThumbs = true; // User explicitly interacted
        if (thumbStrip) {
          thumbStrip.scrollBy({ top: 160, behavior: "smooth" });
          setTimeout(updateThumbNav, 250);
        }
      });
    }

    if (thumbStrip) {
      thumbStrip.style.justifyContent = "flex-start";
      thumbStrip.style.alignItems = "center";
      // Disable scroll-behavior smooth during init so no drift
      thumbStrip.style.scrollBehavior = "auto";
      thumbStrip.scrollTop = 0;

      // Only pointer/touch mark user as scrolled — NOT wheel (wheel can fire from page scrolling)
      thumbStrip.addEventListener("pointerdown", markUserScrolled, { passive: true });
      thumbStrip.addEventListener("touchstart", markUserScrolled, { passive: true });

      thumbStrip.addEventListener("scroll", updateThumbNav, { passive: true });
      window.addEventListener("resize", updateThumbNav);

      // Start the RAF lock immediately
      requestAnimationFrame(rafLockThumbTop);

      // Also lock on window load in case images shift layout
      window.addEventListener("load", function () {
        if (!userScrolledThumbs) {
          thumbStrip.scrollTop = 0;
          thumbLockUntil = Date.now() + 800; // extra 800ms after load
          requestAnimationFrame(rafLockThumbTop);
        }
      });
    }

    // Smooth hover wheel scrolling inside the thumbnail strip
    if (thumbStrip && !thumbStrip.dataset.wheelBound) {
      thumbStrip.dataset.wheelBound = "true";
      thumbStrip.addEventListener("wheel", function (e) {
        if (window.innerWidth >= 990 && thumbStrip.scrollHeight > thumbStrip.clientHeight) {
          var atTop = thumbStrip.scrollTop <= 0 && e.deltaY < 0;
          var atBottom = (thumbStrip.scrollTop + thumbStrip.clientHeight >= thumbStrip.scrollHeight - 2) && e.deltaY > 0;
          if (!atTop && !atBottom) {
            e.preventDefault();
            thumbStrip.scrollTop += e.deltaY;
            updateThumbNav();
          }
        }
      }, { passive: false });
    }

    function setActiveMedia(targetId, index) {
      // 1. Pause any playing videos across all slides
      mainSlides.forEach(function (slide) {
        var vid = slide.querySelector("video");
        if (vid && !vid.paused) {
          try { vid.pause(); } catch (e) { }
        }
      });

      // 2. Update thumbnail active states
      var targetIdx = -1;
      thumbItems.forEach(function (thumb, idx) {
        var isMatch = (targetId && thumb.getAttribute("data-media-id") === targetId) || (!targetId && idx === index);
        if (isMatch) {
          thumb.classList.add("is-active");
          thumb.setAttribute("aria-current", "true");
          targetIdx = idx;
        } else {
          thumb.classList.remove("is-active");
          thumb.removeAttribute("aria-current");
        }
      });

      // 3. Ensure active thumbnail is smoothly scrolled into full visibility inside the strip
      if (thumbStrip && targetIdx >= 0) {
        var activeThumb = thumbItems[targetIdx];
        if (activeThumb) {
          if (window.innerWidth >= 990) {
            if (targetIdx === 0) {
              // Always scroll perfectly to the top for the first thumbnail instantly
              thumbStrip.scrollTop = 0;
              try { thumbStrip.scrollTo({ top: 0, behavior: "instant" }); } catch (e) { thumbStrip.scrollTop = 0; }
            } else {
              var top = activeThumb.offsetTop;
              var bottom = top + activeThumb.offsetHeight;
              if (top < thumbStrip.scrollTop) {
                thumbStrip.scrollTo({ top: Math.max(0, top - 6), behavior: "smooth" });
              } else if (bottom > thumbStrip.scrollTop + thumbStrip.clientHeight) {
                thumbStrip.scrollTo({ top: bottom - thumbStrip.clientHeight + 6, behavior: "smooth" });
              }
            }
          } else {
            var left = activeThumb.offsetLeft;
            var right = left + activeThumb.offsetWidth;
            if (left < thumbStrip.scrollLeft) {
              thumbStrip.scrollTo({ left: Math.max(0, left - 8), behavior: "smooth" });
            } else if (right > thumbStrip.scrollLeft + thumbStrip.clientWidth) {
              thumbStrip.scrollTo({ left: right - thumbStrip.clientWidth + 8, behavior: "smooth" });
            }
          }
          setTimeout(updateThumbNav, 200);
        }
      }

      // 4. Update main viewer slide active states
      mainSlides.forEach(function (slide, idx) {
        var isMatch = (targetId && slide.getAttribute("data-media-id") === targetId) || (!targetId && idx === index);
        if (isMatch) {
          slide.classList.add("is-active");
          var vid = slide.querySelector("video");
          if (vid) {
            // Active slide is a video
            if (zoomBtn) zoomBtn.style.display = "flex";
            if (mainImageWrap) mainImageWrap.style.cursor = "default";
            try {
              var playPromise = vid.play();
              if (playPromise !== undefined) {
                playPromise.catch(function () {
                  // Autoplay blocked by browser policy; user can use controls
                });
              }
            } catch (err) { }
          } else {
            // Active slide is an image
            if (zoomBtn) zoomBtn.style.display = "flex";
            if (mainImageWrap) mainImageWrap.style.cursor = "zoom-in";
            var img = slide.querySelector("img");
            if (img && zoomImg) {
              zoomImg.src = img.src;
            }
          }
        } else {
          slide.classList.remove("is-active");
        }
      });
    }

    thumbItems.forEach(function (thumb, idx) {
      thumb.addEventListener("click", function (e) {
        e.preventDefault();
        if (idx !== 0) {
          userScrolledThumbs = true;
        }
        var targetId = this.getAttribute("data-media-id");
        setActiveMedia(targetId, idx);
      });
    });

    // Open Zoom Modal
    function openZoom() {
      if (typeof window.openProductLightbox === "function") {
        var activeSlide = gallery.querySelector(".yumi-product-gallery__slide.is-active");
        var mid = activeSlide ? activeSlide.getAttribute("data-media-id") : null;
        var foundIdx = 0;
        var mediaList = window.__PLB_MEDIA__ || window.__PLB_IMAGES__;
        if (mid && mediaList) {
          for (var i = 0; i < mediaList.length; i++) {
            if (String(mediaList[i].id) === String(mid)) {
              foundIdx = i;
              break;
            }
          }
        }
        window.openProductLightbox(foundIdx);
        return;
      }

      var activeSlide = gallery.querySelector(".yumi-product-gallery__slide.is-active");
      if (!activeSlide || activeSlide.querySelector("video")) return;
      var img = activeSlide.querySelector("img");
      if (img && zoomImg) {
        zoomImg.src = img.src;
      }
      if (zoomBackdrop) zoomBackdrop.classList.add("is-active");
      if (zoomModal) zoomModal.classList.add("is-active");
      document.body.style.overflow = "hidden";
    }

    function closeZoom() {
      if (zoomBackdrop) zoomBackdrop.classList.remove("is-active");
      if (zoomModal) zoomModal.classList.remove("is-active");
      document.body.style.overflow = "";
    }

    if (zoomBtn) {
      zoomBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        openZoom();
      });
    }

    if (mainImageWrap) {
      mainImageWrap.addEventListener("click", function (e) {
        // Never trigger image zoom if clicking video, video controls, or inside video wrapper
        if (e.target.closest("video") || e.target.tagName === "VIDEO" || e.target.closest(".yumi-video-slide-inner")) {
          return;
        }
        if (!e.target.closest("#zoomBtn")) {
          openZoom();
        }
      });
    }

    if (zoomClose) {
      zoomClose.addEventListener("click", closeZoom);
    }
    if (zoomBackdrop) {
      zoomBackdrop.addEventListener("click", closeZoom);
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && zoomModal && zoomModal.classList.contains("is-active")) {
        closeZoom();
      }
    });

    // Ensure first slide is active on init if none is
    var activeSlide = gallery.querySelector(".yumi-product-gallery__slide.is-active");
    if (!activeSlide && mainSlides.length > 0) {
      setActiveMedia(null, 0);
    } else {
      // Already have an active slide - just ensure thumbStrip is at top
      if (!userScrolledThumbs && thumbStrip) {
        thumbStrip.scrollTop = 0;
        thumbLockUntil = Date.now() + 1500;
        requestAnimationFrame(rafLockThumbTop);
      }
    }
  }

  initProductGallery();
  /* --------------------------------------------------------------------------
     10. UNIFIED PRODUCT DESCRIPTION HEADINGS NORMALIZER
     -------------------------------------------------------------------------- */
  function normalizeProductDescriptionHeadings() {
    var descContainers = document.querySelectorAll(
      ".product__description, .product__accordion .accordion__content, .yumi-accordion__content, .product-details-tabs .tab-content, .rte"
    );
    if (!descContainers.length) return;

    var knownHeadings = [
      "key features",
      "size & dimensions",
      "size and dimensions",
      "sizes & dimensions",
      "size & dimension",
      "dimensions",
      "care instructions",
      "material & care",
      "material & care instructions",
      "wash care",
      "wash & care",
      "product details",
      "product specifications",
      "specifications",
      "features",
      "highlights",
      "package includes",
      "about the product",
      "description"
    ];

    descContainers.forEach(function (container) {
      // 1. Identify headings and convert them to consistent heading elements
      var allNodes = container.querySelectorAll("p, div, span, strong, b, h1, h2, h3, h4, h5, h6");
      allNodes.forEach(function (el) {
        var cleanText = (el.textContent || "").trim().toLowerCase().replace(/:$/, "").replace(/\s+/g, " ");
        if (knownHeadings.indexOf(cleanText) !== -1) {
          // If this is a standalone header paragraph / div / span
          var isStandalone = (el.children.length === 0) ||
            (el.children.length === 1 && ["STRONG", "B", "SPAN", "EM"].indexOf(el.firstElementChild.tagName) !== -1);

          if (isStandalone) {
            el.classList.add("product-desc-heading");
            // If parent is a paragraph containing only this element, add class to parent too
            if (el.parentElement && el.parentElement.tagName === "P" && el.parentElement.children.length === 1) {
              el.parentElement.classList.add("product-desc-heading");
            }
          }
        }
      });

      // 2. Remove inline font styles so theme CSS takes full control
      container.querySelectorAll("*").forEach(function (el) {
        if (el.style) {
          el.style.fontFamily = "";
          if (el.tagName !== "IMG" && el.tagName !== "SVG") {
            if (el.style.fontSize && !el.classList.contains("product-desc-heading")) {
              el.style.fontSize = "";
            }
          }
        }
      });
    });
  }

  normalizeProductDescriptionHeadings();

  // Initial calculation on page load
  recalculateGrandTotal();

});


